import { ApiBase, Options, MethodInfo } from '../../core/ApiBase';
import { pList } from '../../models/.catalog';

export default class GetirParselGeoJsonApi extends ApiBase<pList, any> {
  constructor(options?: Options) {
    super(
      new MethodInfo({
        MethodUrl: '/GetirParselGeoJson',
      }),
      options
    );
    this._ServiceUrl = '/services/Parseller.asmx';
  }
}
